import { jsx as _jsx } from "react/jsx-runtime";
import { extendCommonButtonsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useCallback, useState } from "react";
import { useStylesheet } from "../../contexts";
import { AsciiSpinner } from "..";
import { useBannerOrBlocker } from "../../hooks";
const Button = (param)=>{
    let { type, children, busyOnClick = true, forceShow, onClick, framed, sticky, order, className, ...rest } = param;
    const { buttons: { [type]: Button }, framed: framedClass, stickyButton: stickyClass, forceShowButton: forceShowButtonClassName } = useStylesheet().extend(...extendCommonButtonsStylesheet);
    const { decision, saveButton } = useBannerOrBlocker();
    const buttonType = type === "save" ? saveButton.type : decision[type];
    const [isBusy, setIsBusy] = useState(false);
    const handleOnClick = useCallback((e)=>{
        if (!isBusy) {
            e.preventDefault();
            busyOnClick && setIsBusy(true);
            onClick == null ? void 0 : onClick(e);
        }
    }, [
        onClick,
        isBusy,
        busyOnClick
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        onClick: handleOnClick,
        className: [
            framed ? framedClass : undefined,
            sticky ? stickyClass : undefined,
            forceShow ? forceShowButtonClassName : undefined,
            className
        ].filter(Boolean).join(" "),
        style: {
            order
        },
        "data-order": order,
        role: buttonType === "button" ? "button" : undefined,
        ...rest,
        children: /*#__PURE__*/ _jsx("span", {
            children: isBusy ? /*#__PURE__*/ _jsx(AsciiSpinner, {}) : children
        })
    });
};
export { Button };
